import { useContext } from 'react';
import { AdminContext } from '../../contexts/AdminContext';
import { NotificationObject } from '../../interfaces/APIInterface';
import { isNullUndefEmpty } from '../../ts/common';
import './NotificationsChild.css'
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { CardHeader } from '@mui/material';

interface NotificationsChildProps {
    setNotificationToView: React.Dispatch<React.SetStateAction<NotificationObject>>,
    setViewNotification: React.Dispatch<React.SetStateAction<boolean>>,
    acknowledgeNotification: (notificationId: string, notificationApplication: string) => Promise<void>,
    notification: NotificationObject,
    userRedirect: (navigateTo: {pathname: string, search: string}) => void
}

const NotificationsChild = (props: NotificationsChildProps) => {
    const {adminCredentials, getToken} = useContext(AdminContext);
    const isEmailRegex = /^[^@]+@[^@]+\.[^@]+$/;

    return (
        <Card variant='outlined' onClick={() => { props.setViewNotification(true); props.setNotificationToView(props.notification) }}>
            <CardHeader disableTypography title={"Error | " + props.notification.notificationType} />
            <CardContent>
                <Typography variant='h6'> Notification ID: {props.notification.id} </Typography>
                <Typography variant='body1'>Application: {adminCredentials.allApplications[props.notification.applicationId]?.name}</Typography>
                {props.notification.userId === undefined && props.notification.userId === '' ? <></> : 
                !isEmailRegex.test(props.notification.userId) ? <Typography variant='body1'>User: <Button className="link-imitation" onClick={() => props.userRedirect({pathname: `/edit-user`, search: `?user=${props.notification.userId}&country=${props.notification.country}`})}>{!isNullUndefEmpty(props.notification.userEmail) ? props.notification.userEmail : !isNullUndefEmpty(props.notification.userFirstName) && !isNullUndefEmpty(props.notification.userLastName) ? props.notification.userFirstName + ' ' + props.notification.userLastName : props.notification.userId}</Button></Typography> : 
                <Typography variant='body1'>Email Address: <Button className="link-imitation" onClick={() => props.userRedirect({pathname: `/search-users`, search :`?email=${props.notification.userId}`})}>{props.notification.userId}</Button></Typography>}
                <Typography variant='body1'> Time: {new Date(props.notification.tsCreatedAt * 1000).toLocaleString()} </Typography>
                <Typography variant='body1'> {props.notification.notificationMessage} </Typography>
                </CardContent>
                <CardActions>
                    {props.notification.adminAcknowledged ?
                        null
                        : <Button 
                            onClick={(e) => {
                                e.stopPropagation(); 
                                props.acknowledgeNotification(props.notification.id, props.notification.applicationId)
                            }}>
                            Acknowledge
                        </Button>}
                </CardActions>
        </Card>
    )
}

export default NotificationsChild
